import CloseIcon from '@mui/icons-material/Close'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import { connectField, getValueByPath, useFormContext } from 'dynamic-uniforms'
import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { filterDOMProps } from './filterDOMProps'
import { joinName } from './joinName'

export type ListDelFieldProps = {
  cta?: string
  icon?: ReactNode
  disabled?: boolean
  readOnly?: boolean
  name: string
  [key: string]: any
}

function ListDel({
  disabled,
  cta,
  icon = <CloseIcon />,
  name,
  readOnly,
  ...props
}: ListDelFieldProps) {
  const { t } = useTranslation('@cibo/ui/Uniforms')
  const ctx = useFormContext()

  const nameParts = joinName(null, name) as string[]
  const nameIndex = +nameParts[nameParts.length - 1]
  const parentName = joinName(nameParts.slice(0, -1)) as string
  const parentProps = ctx.bridge.getProps(parentName)
  const parentValue = (getValueByPath(ctx.model, parentName) ?? []) as unknown[]

  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  disabled ||= readOnly || parentProps.minCount! >= parentValue.length

  return (
    <Tooltip title={cta || t('removeItem')}>
      <IconButton
        data-testid={`list-remove-button-${parentName}`}
        {...filterDOMProps(props)}
        disabled={disabled}
        onClick={() => {
          const value = parentValue.slice()
          value.splice(nameIndex, 1)
          ctx.onChange(parentName, value)
        }}
        color="primary"
        size="small"
      >
        {icon}
      </IconButton>
    </Tooltip>
  )
}

export default connectField<ListDelFieldProps>(ListDel, {
  initialValue: false,
  kind: 'leaf',
})
